/**
 * Radio: DiscountedPrice × (BoughtSeconds / 10) × unit × timeline
 *
 * Same shape as Television. Timeslot is priced per 10-second slot.
 */
import { slotTenFactor } from './multipliers';

export function calculateRadioTotal(variant, selection) {
  const discountedPrice = Number(variant?.DiscountedPrice) || 0;
  const units = Number(selection?.unitsToBebought) || 1;
  const timeline = Number(selection?.timelineToBought) || 1;
  const slot = slotTenFactor(selection?.BoughtSeconds);
  return discountedPrice * slot * units * timeline;
}
